import { ComprovantePayload } from "@/utils/comprovante";
import { API_CONSTANT_MAP } from "./paths";
import requestApi from "./requestApi";

export type GetBoletosFiltro = {
  status?: string[];
  dataInicio?: string;
  dataFim?: string;
  unidadeIds?: number[];
  busca?: string;
};

export const getBoletos = async (filtro?: GetBoletosFiltro) => {
  const params = new URLSearchParams();
  filtro?.status?.forEach((s) => params.append("status", s));
  if (filtro?.dataInicio) params.append("dataInicio", filtro.dataInicio);
  if (filtro?.dataFim) params.append("dataFim", filtro.dataFim);
  filtro?.unidadeIds?.forEach((u) => params.append("unidadeIds", String(u)));
  if (filtro?.busca) params.append("busca", filtro.busca);

  const query = params.toString();
  const url = query ? `${API_CONSTANT_MAP.boleto}?${query}` : API_CONSTANT_MAP.boleto;
  return requestApi.get(url);
};

export const emitirBoletos = (ids: number[]) => {
  return requestApi.put(`${API_CONSTANT_MAP.boleto}/emitir`, { ids });
};

export const liquidarBoletos = (ids: number[], dataLiquidacao?: string) => {
  return requestApi.put(`${API_CONSTANT_MAP.boleto}/liquidar`, { ids, dataLiquidacao });
};

export const cancelarBoletos = (ids: number[], motivo: string) => {
  return requestApi.put(`${API_CONSTANT_MAP.boleto}/cancelar`, { ids, motivo });
};

export const trocarPagamentoBoleto = (payload: {
  id: number;
  pagamentoId: number;
  cv?: number;
  dataTransacao?: string;
  /** Comprovante do PIX/Transferência, opcional — pode ser anexado depois. */
  comprovante?: ComprovantePayload | null;
}) => {
  return requestApi.put(`${API_CONSTANT_MAP.boleto}/trocar`, payload);
};

// O processamento de boletos em atraso é disparado pelo backend no processo de
// login (primeiro login do dia), com controle atômico na tabela
// BoletoProcessamentoAtraso — independente do usuário e sem chamadas do frontend.
export const processarBoletosAtrasados = () => {
  return requestApi.put(`${API_CONSTANT_MAP.boleto}/processar-atrasos`, {});
};
